import { render } from "./GymSection.vue?vue&type=template&id=e94d77ec&scoped=true"
import script from "./GymSection.vue?vue&type=script&lang=js"
export * from "./GymSection.vue?vue&type=script&lang=js"

import "./GymSection.vue?vue&type=style&index=0&id=e94d77ec&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guifernandespro\\development\\projects\\vue_icon-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e94d77ec"]])

export default __exports__